export const TBD = () => <span className="text-gray-500">TBD</span>;

export const NotAvailable = ({ className, text }) => (
  <span className={`text-secondary ${className}`}>{text || "Not Available"}</span>
);

export const Missing = ({ className, text }) => <span className={className}>{text}</span>;
